import * as Types from '../Constants/AllConstants';

// Reducer for fetching all groups (paginated)
export const GetAllGroupsReducer = (
  state = { groups: [], pages: 0, page: 0, loading: false, error: null },
  action
) => {
  switch (action.type) {
    case Types.GROUPS_LIST_REQUEST:
      return { ...state, loading: true, error: null }; // Clear error on new request
    case Types.GROUPS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null, // Clear error on success
        groups: action.payload.content,
        pages: action.payload.page.totalPages,
        page: action.payload.page.number,
      };
    case Types.GROUPS_LIST_FAIL:
      return { ...state, loading: false, error: action.payload };
    case Types.GROUPS_LIST_RESET:
      return { groups: [], pages: 0, page: 0, loading: false, error: null };
    default:
      return state;
  }
};

// Reducer for fetching all groups (unpaged)
export const GetUnpagedGroupsReducer = (
  state = { unpagedGroups: [], loading: false, error: null },
  action
) => {
  switch (action.type) {
    case Types.GROUPS_UNPAGED_REQUEST:
      return { ...state, loading: true, error: null };
    case Types.GROUPS_UNPAGED_SUCCESS:
      return { ...state, loading: false, error: null, unpagedGroups: action.payload };
    case Types.GROUPS_UNPAGED_FAIL:
      return { ...state, loading: false, error: action.payload };
    case Types.GROUPS_UNPAGED_RESET:
      return { unpagedGroups: [], loading: false, error: null };
    default:
      return state;
  }
};

// Reducer for fetching a single group by ID
export const GetGroupByIdReducer = (state = { group: {}, loading: false, error: null }, action) => {
  switch (action.type) {
    case Types.GROUP_DETAILS_REQUEST:
      return { ...state, loading: true, error: null };
    case Types.GROUP_DETAILS_SUCCESS:
      return { loading: false, error: null, group: action.payload };
    case Types.GROUP_DETAILS_FAIL:
      return { loading: false, error: action.payload, group: {} };
    case Types.GROUP_DETAILS_RESET:
      return { group: {}, loading: false, error: null };
    default:
      return state;
  }
};

// Reducer for creating a group
export const CreateGroupReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.GROUP_CREATE_REQUEST:
      return { loading: true, error: null };
    case Types.GROUP_CREATE_SUCCESS:
      return { loading: false, success: true, error: null, group: action.payload };
    case Types.GROUP_CREATE_FAIL:
      return { loading: false, error: action.payload, success: false };
    case Types.GROUP_CREATE_RESET:
      return {};
    default:
      return state;
  }
};

// Reducer for updating a group
export const UpdateGroupReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.GROUP_UPDATE_REQUEST:
      return { loading: true, error: null };
    case Types.GROUP_UPDATE_SUCCESS:
      return { loading: false, success: true, error: null, group: action.payload };
    case Types.GROUP_UPDATE_FAIL:
      return { loading: false, error: action.payload, success: false };
    case Types.GROUP_UPDATE_RESET:
      return {};
    default:
      return state;
  }
};

// Reducer for deleting a group
export const DeleteGroupReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.GROUP_DELETE_REQUEST:
      return { loading: true, error: null };
    case Types.GROUP_DELETE_SUCCESS:
      return { loading: false, success: true, error: null };
    case Types.GROUP_DELETE_FAIL:
      return { loading: false, error: action.payload, success: false };
    case Types.GROUP_DELETE_RESET:
      return {};
    default:
      return state;
  }
};